module.exports = __webpack_public_path__ + "img/gongyingshang.7860f3dd.png";